import React, { useState, useEffect } from "react";
import "./PopularCategories.css";

const PopularCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true); // For loading state
  const [error, setError] = useState(null);     // For error handling

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch("https://khanehyeghtesad.com:8000/api/category/count/");
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        // Transform the data into an array of objects
        const transformedCategories = Object.entries(data).map(([name, count], index) => ({
          id: index + 1, // Assign a unique ID (you might want to use a better unique identifier)
          name,
          count,
        }));

        setCategories(transformedCategories);
      } catch (err) {
        console.error("Failed to fetch categories:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []); // Empty dependency array ensures this runs once on mount

  if (loading) {
    return <div className="popular-categories-latest">در حال بارگذاری...</div>;
  }

  if (error) {
    return <div className="popular-categories-latest">خطا: {error}</div>;
  }

  return (
    <div className="popular-categories-latest">
      <h3 className="categories-title-latest">دسته‌بندی‌های محبوب</h3>
      <ul className="categories-list-latest">
        {categories.map((category) => (
          <li key={category.id} className="category-item-latest">
            <span className="category-name-latest">{category.name}</span>
            <span className="category-count-latest">{category.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PopularCategories;
